import { Alert as MuiAlert, AlertProps as MuiAlertProps, Zoom } from '@mui/material';
import React, { Component } from 'react';
import InfoIcon from '../resources/images/icons-info-circle.svg';

interface AlertProps extends MuiAlertProps {
  scrollTo: boolean;
  severity: 'success' | 'error' | 'warning' | 'info';
  showIcon: boolean;
  icon: React.ReactNode;
}

export class Alert extends Component<Partial<AlertProps>> {
  static defaultProps = {
    scrollTo: false,
  };

  ref: React.RefObject<HTMLDivElement | null>;

  constructor(props: Partial<AlertProps>) {
    super(props);

    this.ref = React.createRef();
  }

  componentDidMount() {
    const { scrollTo } = this.props;
    if (scrollTo) this.ref.current?.scrollIntoView({ behavior: 'smooth' });
  }

  componentDidUpdate(prevProps: Partial<AlertProps>) {
    const { scrollTo } = this.props;
    // Only when the message itself changes. Scrolling on every update pulls the viewport back here on
    // any parent setState - a keystroke in a long form while an error is showing - rather than when
    // there is something new to read.
    if (scrollTo && prevProps.children !== this.props.children)
      this.ref.current?.scrollIntoView({ behavior: 'smooth' });
  }

  render() {
    const { severity, showIcon = true, icon } = this.props;

    return (
      <div ref={this.ref} className='klayo-alert_container'>
        <Zoom in={true}>
          <MuiAlert
            {...this.props}
            icon={icon ? icon : severity === 'info' && showIcon ? <InfoIcon /> : false}
            className='klayo-alert'
          />
        </Zoom>
      </div>
    );
  }
}
